<template>
  <modal :title="title"  @close="$emit('close')" :show-close-button="true" class="modal__stripe">
    <stripe-card :button-text="displayPrice" @done="cb" ></stripe-card>
  </modal>
</template>

<script>
import Modal from '@/components/utils/Modal';
import ModalJS from '@/components/classes/Modal';
import StripeCard from '@/components/StripeCard';
import HelpersMixin from '@/components/mixins/HelpersMixin';

export default {
  name: 'subscribe-modal',
  mixins: [HelpersMixin],
  components: {
    Modal,
    StripeCard,
  },
  props: {
    price: {
      required: true,
      type: Object,
    },
    currency: {
      required: true,
      type: Object,
    },
    cb: {
      required: true,
      type: Function,
    },
  },
  data() {
    return {
      modal: new ModalJS({
        subscribe: false,
      }),
    };
  },
  computed: {
    title() {
      if (this.price === null) return '';
      let durationUnit = null;
      if (this.price.duration_unit === 'month') {
        durationUnit = 'Monthly';
      }
      if (this.price.duration_unit === 'year') {
        durationUnit = 'Yearly';
      }
      return `${durationUnit} subscription`;
    },
    displayPrice() {
      const p = this.getAmountFromPrice(this.price);
      return `pay ${this.currency.symbol}${p}`;
    },
  },
};
</script>
